//export const BaseURL = "http://localhost:8000/api";
//export const media = "http://localhost:8000/";

export const BaseURL = "https://www.api.artcodey.com/api";
export const media = "https://www.api.artcodey.com/";
